import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doctorServices } from "../../services/doctroServices";

const STATUSES = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
});

const initialState = {
  noticeStatus: false,
  adminDetails: {},
  doctorLength: "",
  doctorList: [],
  doctorListLength: "",
  doctorListing: [],
  patientLength: "",
  patientList: [],
  appointmentLength: "",
  appointmentList: [],
  status: {
    admin: STATUSES.IDLE,
    doctors: STATUSES.IDLE,
    patients: STATUSES.IDLE,
    appointments: STATUSES.IDLE,
  },
  showAppointment: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setShowAppointment: (state, action) => {
      state.showAppointment = action.payload;
    },
    setNoticeStatus: (state, action) => {
      state.noticeStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Admin Details
    builder
      .addCase(fetchAdminDetails.pending, (state) => {
        state.status.admin = STATUSES.LOADING;
      })
      .addCase(fetchAdminDetails.fulfilled, (state, action) => {
        state.adminDetails = action.payload;
        state.status.admin = STATUSES.IDLE;
      })
      .addCase(fetchAdminDetails.rejected, (state) => {
        state.status.admin = STATUSES.ERROR;
      })
      // Doctor List
      .addCase(fetchDoctorList.pending, (state) => {
        state.status.doctors = STATUSES.LOADING;
      })
      .addCase(fetchDoctorList.fulfilled, (state, action) => {
        state.doctorList = action.payload;
        state.doctorLength = action.payload.length;
        state.status.doctors = STATUSES.IDLE;
      })
      .addCase(fetchDoctorList.rejected, (state) => {
        state.status.doctors = STATUSES.ERROR;
      })
      // Doctor Listing
      .addCase(fetchDoctors.pending, (state) => {
        state.status.doctors = STATUSES.LOADING;
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.doctorListing = action.payload;
        state.doctorListLength = action.payload.length;
        state.status.doctors = STATUSES.IDLE;
      })
      .addCase(fetchDoctors.rejected, (state) => {
        state.status.doctors = STATUSES.ERROR;
      })
      // Patient List
      .addCase(fetchPatientList.pending, (state) => {
        state.status.patients = STATUSES.LOADING;
      })
      .addCase(fetchPatientList.fulfilled, (state, action) => {
        state.patientList = action.payload;
        state.patientLength = action.payload.total;
        state.status.patients = STATUSES.IDLE;
      })
      .addCase(fetchPatientList.rejected, (state) => {
        state.status.patients = STATUSES.ERROR;
      })
      // Appointment List
      .addCase(fetchAppointmentList.pending, (state) => {
        state.status.appointments = STATUSES.LOADING;
      })
      .addCase(fetchAppointmentList.fulfilled, (state, action) => {
        state.appointmentList = action.payload;
        state.appointmentLength = action.payload.total;
        state.status.appointments = STATUSES.IDLE;
      })
      .addCase(fetchAppointmentList.rejected, (state) => {
        state.status.appointments = STATUSES.ERROR;
      });
  },
});

export const {
  setShowAppointment,
  setNoticeStatus,
} = userSlice.actions;
export default userSlice.reducer;

// Thunks

export const fetchAdminDetails = createAsyncThunk("admin/fetch", async () => {
  const data = await doctorServices.getAdminDetails();
  return data;
});

export const fetchDoctorList = createAsyncThunk(
  "doctors/fetch",
  async (params) => {
    const data = await doctorServices.getDoctorsList(params);
    return data;
  }
);

export const fetchDoctors = createAsyncThunk("doctorlist/fetch", async () => {
  const data = await doctorServices.getDoctors();
  return data;
});

export const fetchPatientList = createAsyncThunk(
  "patient/fetch",
  async (params) => {
    const data = await doctorServices.getPatientsList(params);
    return data;
  }
);

export const fetchAppointmentList = createAsyncThunk(
  "appointment/fetch",
  async (params) => {
    const data = await doctorServices.getAppointmentsList(params);
    return data;
  }
);
